import * as Yup from 'yup'

export const sendMessageSchema = Yup.object().shape({
    to: Yup.array()
        .of(
            Yup.object().shape({
                value: Yup.number().required("Select To User"), // Ensure `value` is a number
                label: Yup.string().required("Select To User"), // Ensure `label` is a string
            })
        )
        .when('isAllUsers', {
            is: false, // Only apply validation when isAllUsers is false
            then: (schema) => schema.min(1, "Select To User"), // Ensure at least one user is selected
            otherwise: (schema) => schema.notRequired(),
        }),
    isAllUsers: Yup.boolean().required(),
    // to: Yup.string().required("Select To User"),
    subject: Yup.string().required("Enter Subject"),
    message: Yup.string().required("Enter Message")
})